import isString from 'lodash/isString';
import isNumber from 'lodash/isNumber';
/**
 * Create a dom element
 * @param  {String} [tag='div']    the tag to create
 * @param  {String} [className=''] the css classes as space separted string
 * @param  {String|Node} [content] optional content
 * @return {Element} The element created
 */
export const create = (tag = 'div', className = '', content) => {
    const element = document.createElement(tag);
    element.className = className;

    if (isString(content) || isNumber(content)) {
        element.innerHTML = content;
    }

    if (content instanceof Node) {
        element.appendChild(content);
    }

    return element;
};

/**
 * Create a document fragment
 * @return {DocumentFragment} The fragment created
 */
export const createFragment = () => {
    return document.createDocumentFragment();
};

/**
 * Removes the child nodes from an element
 * @param  {Element} element The dom element
 * @return {void}
 */
export const removeChildren = element => {
    while (element.firstChild) {
        element.removeChild(element.firstChild);
    }
};

/**
 * Calls the callback in the browser repaint
 * @param  {Function} callback The callback
 * @return {Function} A function to cancel the callback
 */
export const nextRepaint = callback => window.requestAnimationFrame(callback);

/**
 * Stop jQuery mobile from triggering unnecessary event listeners
 *
 * @param {Element} el dom element to use
 * @return {void}
 */
export function stopJqueryMobileEventListeners(el) {
    const stopEventPropagation = e => e.stopPropagation();
    el.addEventListener('touchend', stopEventPropagation);
    el.addEventListener('touchstart', stopEventPropagation);
    el.addEventListener('mousedown', stopEventPropagation);
    el.addEventListener('mouseup', stopEventPropagation);
}

/**
 * Adds callback for when the DOM content is loaded
 *
 * @param {Function} callback A function to call
 * @return {void}
 */
export function onDomContentLoaded(callback) {
    document.addEventListener('DOMContentLoaded', callback);
}

/**
 * Return the selected option for a select box
 *
 * @param  {HTMLSelectElement} select box dom element
 * @return {HTMLOptionElement} The currently selected option dom element
 */
export function getSelectCurrentOption(select) {
    return select.options[select.selectedIndex];
}
